class GroupPermissionsRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'GroupPermissions';

        super(entityName);
    }

    show = () => {
        try {
            App.Views.GroupPermissions.manageTab();
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "Error on show group permission");
            error.console();
        }
    }

    getGroupsAndCreateList = (filterToSearch) => {
        let error = null,
            ajax = null,
            groupPermissionView = null,
            url = 'Group/restrictions?criteria={"filters":["id","name"]}',
            filter = {};

        try {
            groupPermissionView = App.Views.GroupPermissions;
            ajax = new Monet.Ajax();

            if (filterToSearch) {
                filter = filterToSearch;
            }

            ajax.url = url;
            ajax.method = "POST";
            ajax.data = filter;
            ajax.success = function (data) {
                if (data) {
                    groupPermissionView.createListGroups(data);
                }
            };

            ajax.error = function (response) {
                Monet.Configurations.errorNotification(null, response);
            };

            ajax.send();
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, 'Error on get groups and create list.');
            error.console();
        }
    }

    populateTreeView = (result, groupId) => {
        let data = null,
            treeViewPermissions = null;

        const updateTreeViewDataPro = function (data) {
            return data.map(item => {
                const proKeys = ["proactiveRouteOptConfig.userinterface.description", "ProactiveRouteOpt.userinterface.description"];
                if (item.userInterfaces) {
                    item.userInterfaces = item.userInterfaces.reduce((acc, userInterface) => {
                        if (proKeys.indexOf(userInterface.name) > -1) {
                            if (Greenmile.Utils.hasPermission("PRO")) {
                                acc.push(userInterface);
                            }
                        } else {
                            acc.push(userInterface);
                        }
                        return acc;
                    }, []);
                }
                return item;
            });
        }

        const translateNameOfPermissions = function (data) {
            const i18n = Monet.I18n;
            for (let i in data) {
                if (typeof data[i] === 'object') {
                    translateNameOfPermissions(data[i]);
                } else if (i === 'name') {
                    data[i] = i18n.getResourcesByKey(data[i]);
                }
            }
        };

        if (result) {
            data = updateTreeViewDataPro(result);
            translateNameOfPermissions(data);
            treeViewPermissions = new Greenmile.GroupPermissions.TreeViewPermissions();

            Monet.Session.GroupPermission = Monet.Session.GroupPermission || {};
            Monet.Session.GroupPermission.nodes = data;
            Monet.Session.GroupPermission.groupId = groupId;
            Monet.Session.GroupPermission.treeView = treeViewPermissions;

            treeViewPermissions.render(data);
        }
    }

    getPermissionsByGroupAndPopulateGrid = (groupId) => {
        let error = null,
            _groupId = groupId,
            ajax = null;

        try {
            if (typeof groupId === 'string') {
                _groupId = parseInt(groupId, 10);
            }

            if (_groupId) {
                let container = document.querySelector("#containerPermissions .form_section_header");
                const loading = document.createElement("img");

                ajax = new Monet.Ajax();
                ajax.url = 'Group/' + _groupId + '/permissions';
                ajax.success = (result) => {
                    this.populateTreeView(result, _groupId);
                    container.removeChild(loading);
                    $('#loading_img').hide();
                };

                ajax.error = function (response) {
                    Monet.Configurations.errorNotification(null, response);
                };

                ajax.loading = function () {
                    loading.className = "groupPermission loading";
                    loading.src = require("static/images/general/loading_blue.svg");
                    container = container.parentElement;
                    container.appendChild(loading);
                };

                ajax.loading();
                ajax.send();
            }
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, 'Error on get permissions by group and populate grid.');
            error.console();
        }
    }

    ajaxSuccessForUpdate = () => {
        App.Views.GroupPermissions.afterSuccessUpdate();

        // Refresh the permissions grid after successful update
        const groupId = Monet.Session.GroupPermission?.groupId;
        if (groupId) {
            this.getPermissionsByGroupAndPopulateGrid(groupId);
        }
    }

    ajaxErrorAfterUpdate = (response, callbackForError) => {
        const treeView = jQuery.jstree._reference("#treeView");
        treeView.data.core.locked = false;
        App.Views.GroupPermissions.afterErrorUpdate(response, callbackForError);
    }

    update = (groupId, type, data, callbackForError) => {
        const ajax = new Monet.Ajax();

        $('#loading_img').show();

        ajax.url = 'Group/' + groupId + '/' + type + '/grant';
        ajax.method = 'PUT';
        ajax.data = data;
        ajax.success = () => {
            this.ajaxSuccessForUpdate(data, type);
        };

        ajax.error = (response) => {
            this.ajaxErrorAfterUpdate(response, callbackForError);
        };

        ajax.send();
    }

    updateAllPermissionsByModule = (groupId, moduleId, allow, callbackForError) => {
        let error = null,
            module = {},
            _groupId = null,
            _moduleId = null,
            _allow = false;

        try {
            if (groupId) {
                _groupId = parseInt(groupId, 10);
            }

            if (moduleId) {
                _moduleId = parseInt(moduleId, 10);
            }

            if (allow) {
                _allow = allow;
            }

            if (_moduleId && _groupId) {
                module.id = _moduleId;
                module.active = _allow;
                this.update(_groupId, 'module', module, callbackForError);
            }
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, 'Error on update all permissions by module');
            error.console();
        }
    }

    updateAllPermissionByUserInterface = (groupId, userInterfaceId, allow, callbackForError) => {
        let error = null,
            userInterface = {},
            _groupId = null,
            _userInterfaceId = null,
            _allow = false;

        try {
            if (userInterfaceId) {
                _userInterfaceId = parseInt(userInterfaceId, 10);
            }

            if (groupId) {
                _groupId = groupId;
            }

            if (allow) {
                _allow = allow;
            }

            if (_groupId && _userInterfaceId) {
                userInterface.id = _userInterfaceId;
                userInterface.active = _allow;
                this.update(_groupId, 'userInterface', userInterface, callbackForError);
            }
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, 'Error on update all permissions by user interface');
            error.console();
        }
    }

    updatePermissions = (groupId, permissions, allow, callbackForError) => {
        var __permissions = permissions;
        var __permissionsLength;

        if (__permissions) {
            __permissionsLength = __permissions.length;

            for (var i = 0; i < __permissionsLength; i++) {
                const id = __permissions[i];
                this.updatePermission(groupId, id, allow, callbackForError);
            }
        }
    }

    updatePermission = (groupId, permissionId, allow, callbackForError) => {
        let error = null,
            permission = {},
            _groupId = null,
            _permissionId = null,
            _allow = false;

        try {
            if (groupId) {
                _groupId = groupId;
            }

            if (permissionId) {
                _permissionId = parseInt(permissionId, 10);
            }

            if (allow) {
                _allow = allow;
            }

            if (_groupId && _permissionId) {
                permission.id = _permissionId;
                permission.active = _allow;
                this.update(_groupId, 'permission', permission, callbackForError);
            }
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, 'Error on update permission');
            error.console();
        }
    }
}

App.Routers.GroupPermissions = GroupPermissionsRouter;

